export default "__VITE_ASSET__DM85UTAL__ 1200w";